import { Stack, styled } from "@mui/material";
import { useAuth } from "../../../api/auth/useAuth";
import { AdminContractDetails } from "../contracts/views/AdminContractDetails";
import { BrokerContractDetails } from "../contracts/views/BrokerContractDetails";
import { useContractLinks } from "../contracts/hooks/useContractLinks";

export const ContractDetailPage = () => {
  const { isAdmin } = useAuth();
  const { contract } = useContractLinks();

  if (!contract) {
    return null;
  }

  if (isAdmin) {
    return <AdminContractDetails />;
  }

  return <BrokerContractDetails />;
};

export const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0, 3, 0),
  flexGrow: 1,
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(0, 6, 0),
  },
  [theme.breakpoints.up("xl")]: {
    padding: theme.spacing(0, 9, 0),
  },
}));
